<template>
  <main class="mant">
    <div class="mant-card">
      <img class="mant-logo" :src="require('@/assets/img/logo_santo_domingo_dark.png')" alt="Logo de la Parroquia Castrense de Santo Domingo" />
      <span class="mant-icon"><span class="material-symbols-outlined">construction</span></span>
      <h1 class="mant-title">Estamos mejorando la web</h1>
      <p class="mant-text">La página está en mantenimiento. Vuelve a visitarnos en unos minutos.</p>

      <div class="mant-contact">
        <a v-if="$root.constantes.tlf.iglesia" :href="`tel:${$root.constantes.tlf.iglesia}`">
          <span class="material-symbols-outlined">call</span>{{ $root.constantes.tlf.iglesia }}
        </a>
        <a v-if="$root.constantes.email.iglesia" :href="`mailto:${$root.constantes.email.iglesia}`">
          <span class="material-symbols-outlined">mail</span>{{ $root.constantes.email.iglesia }}
        </a>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "mantenimientoView",
};
</script>

<style scoped>
.mant {
  display: grid;
  place-items: center;
  min-height: 100vh;
  padding: 24px;
  background: radial-gradient(circle at 30% 20%, #24588f 0%, #0d1b30 70%);
  font-family: var(--sd-font-body);
}

.mant-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 520px;
  text-align: center;
  animation: mant-in 0.8s ease-out both;
}

.mant-logo {
  width: min(360px, 90%);
  margin-bottom: 40px;
}

.mant-icon {
  display: grid;
  place-items: center;
  width: 64px;
  height: 64px;
  margin-bottom: 20px;
  border-radius: 50%;
  background: rgba(227, 196, 126, 0.15);
}

.mant-icon .material-symbols-outlined {
  font-size: 34px;
  color: #e3c47e;
  animation: mant-swing 2.4s ease-in-out infinite;
}

.mant-title {
  margin: 0;
  font-family: var(--sd-font-display);
  font-size: clamp(1.6rem, 5vw, 2.2rem);
  font-weight: 700;
  color: #fff;
}

.mant-text {
  margin: 12px 0 28px;
  font-size: 1.05rem;
  color: rgba(255, 255, 255, 0.75);
}

.mant-contact {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}

.mant-contact a {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
}

.mant-contact a:hover {
  color: #fff;
  text-decoration: underline;
}

.mant-contact .material-symbols-outlined {
  font-size: 18px;
  color: #e3c47e;
}

@keyframes mant-in {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes mant-swing {
  0%,
  100% {
    transform: rotate(-8deg);
  }
  50% {
    transform: rotate(8deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .mant-card,
  .mant-icon .material-symbols-outlined {
    animation: none;
  }
}
</style>
